<template>
    <div class="d-flex flex-wrap tag-wrapper">
        <div class="tag" v-for="(e, i) in extraValue"><small>{{ e.name }}</small></div>
    </div>
</template>

<script>
export default {
    name: "OrganizationActivityCell",
    props: {
        value: {},
        extraValue: {}
    }
}
</script>

<style scoped lang="scss">
    @import "node_modules/bootstrap/scss/functions";
    @import "node_modules/bootstrap/scss/variables";

    .tag {
        background-color: lighten($info, 50%);
        border-radius: 12px;
        padding: 5px 10px;
        margin-right: 7px;
        margin-top: 5px
    }

    .tag-wrapper {
        margin-top: -5px
    }
</style>